import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "light-thead" }
const _hoisted_2 = {
  key: 0,
  class: "db-grid-head-service-th db-grid-head-menu-th",
  style: {"width":"20px","text-align":"center"}
}
const _hoisted_3 = {
  key: 1,
  class: "db-grid-head-service-th",
  style: {"width":"25px","text-align":"center"}
}
const _hoisted_4 = ["indeterminate", "checked"]
const _hoisted_5 = {
  key: 2,
  class: "db-grid-head-service-th",
  style: {"width":"40px","text-align":"center"}
}
const _hoisted_6 = ["onClick", "draggable", "onDragstart", "onDragover", "onDrop"]
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ColumnResizer = _resolveComponent("ColumnResizer")!

  return (_openBlock(), _createElementBlock("thead", _hoisted_1, [
    _createElementVNode("tr", {
      onContextmenu: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onOpenMenu && _ctx.onOpenMenu(...args)))
    }, [
      (_ctx.config.menu)
        ? (_openBlock(), _createElementBlock("th", _hoisted_2, [
            _createElementVNode("a", {
              href: "#",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onOpenMenu && _ctx.onOpenMenu(...args)))
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("i", { class: "icon icon-menu" }, null, -1)
            ]))])
          ]))
        : _createCommentVNode("", true),
      (_ctx.config.rowSelect)
        ? (_openBlock(), _createElementBlock("th", _hoisted_3, [
            _createElementVNode("input", {
              type: "checkbox",
              class: "row-checkbox",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectRows && _ctx.selectRows(...args))),
              indeterminate: _ctx.store.data.rowsSelected === null,
              checked: _ctx.store.data.rowsSelected
            }, null, 8, _hoisted_4)
          ]))
        : _createCommentVNode("", true),
      (_ctx.config.numbering)
        ? (_openBlock(), _createElementBlock("th", _hoisted_5, " No "))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedFields, (fieldkey) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: fieldkey }, [
          (_ctx.visible(_ctx.getField(fieldkey)))
            ? (_openBlock(), _createElementBlock("th", {
                key: 0,
                style: _normalizeStyle(_ctx.getStyleTh(_ctx.getField(fieldkey), fieldkey)),
                class: _normalizeClass(_ctx.getThClasses(fieldkey)),
                onClick: (event) => _ctx.onClickCell(event, fieldkey, _ctx.getField(fieldkey)),
                draggable: _ctx.config.columnDrag !== false,
                onDragstart: (e) => _ctx.onDragStart(e, fieldkey),
                onDragover: (e) => _ctx.onDragOver(e, fieldkey),
                onDragleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
                onDrop: (e) => _ctx.onDrop(e, fieldkey),
                onDragend: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragEnd && _ctx.onDragEnd(...args)))
              }, [
                _createElementVNode("span", {
                  innerHTML: _ctx.getField(fieldkey).description
                }, null, 8, _hoisted_7),
                (_ctx.config.columnResize !== false)
                  ? (_openBlock(), _createBlock(_component_ColumnResizer, {
                      key: 0,
                      fieldKey: fieldkey,
                      isResizing: _ctx.isResizing,
                      currentField: _ctx.currentResizeField || undefined,
                      onStartResize: 
                (e) => _ctx.onStartResize(e, fieldkey, _ctx.getField(fieldkey))
              
                    }, null, 8, ["fieldKey", "isResizing", "currentField", "onStartResize"]))
                  : _createCommentVNode("", true)
              ], 46, _hoisted_6))
            : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ], 32)
  ]))
}